import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHeroList, saveGwDeck } from '../../api/senaApi';
import './SenaGuideWrite.css';

export default function SenaGwDeckWrite() {
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId') || '게스트';

  const [allyHeroes, setAllyHeroes] = useState([]);
  const [selected, setSelected] = useState([null, null, null]);
  const [searches, setSearches] = useState(['', '', '']);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getHeroList('ALLY').then(r => setAllyHeroes(r.data || [])).catch(() => {});
  }, []);

  const handleSelect = (slotIdx, hero) => {
    setSelected(prev => {
      const next = [...prev];
      next[slotIdx] = hero;
      return next;
    });
    setSearches(prev => {
      const next = [...prev];
      next[slotIdx] = '';
      return next;
    });
  };

  const handleRemove = (slotIdx) => {
    setSelected(prev => { const next = [...prev]; next[slotIdx] = null; return next; });
  };

  const handleSave = async () => {
    if (selected.filter(Boolean).length < 3) { alert('영웅 3명을 모두 선택해주세요.'); return; }

    setSaving(true);
    try {
      await saveGwDeck({
        hero1Id: selected[0].heroId,
        hero2Id: selected[1].heroId,
        hero3Id: selected[2].heroId,
        authorNm: userId,
      });
      alert('적군 덱이 등록되었습니다.');
      navigate('/sena/guild-war');
    } catch (e) {
      alert(e?.response?.data || '등록에 실패했습니다.');
    } finally { setSaving(false); }
  };

  return (
    <div className="sena-page">
      <header className="sena-header">
        <button className="siege-back-btn" onClick={() => navigate(-1)}>← 뒤로</button>
        <button className="siege-home-btn" onClick={() => navigate('/sena')}>홈</button>
        <h1 className="sena-header-guild">적군 덱 등록</h1>
        <p className="sena-header-sub">길드전</p>
      </header>

      <div className="gw-container">
        <section className="gw-section">
          <h3 className="gw-section-title">적군 영웅 3명 선택</h3>
          <div className="gw-ally-slots">
            {selected.map((hero, idx) => (
              <div key={idx} className={`gw-ally-slot ${hero ? 'filled' : ''}`}>
                {hero ? (
                  <>
                    <span className="gw-ally-name">{hero.heroNm}</span>
                    <button className="gw-ally-remove" onClick={() => handleRemove(idx)}>×</button>
                  </>
                ) : (
                  <span className="gw-ally-empty">슬롯 {idx + 1}</span>
                )}
              </div>
            ))}
          </div>

          {selected.map((hero, idx) => !hero && (
            <div key={idx} className="gw-hero-search-wrap" style={{ marginBottom: 10 }}>
              <input
                className="gw-hero-search"
                placeholder={`슬롯 ${idx + 1} 영웅 검색...`}
                value={searches[idx]}
                onChange={e => {
                  const next = [...searches]; next[idx] = e.target.value; setSearches(next);
                }}
              />
              {searches[idx].length > 0 && (
                <div className="gw-hero-dropdown">
                  {allyHeroes
                    .filter(h => h.heroNm.includes(searches[idx]))
                    .filter(h => !selected.some(s => s && s.heroId === h.heroId))
                    .map(h => (
                      <button key={h.heroId} className="gw-hero-dropdown-item" onClick={() => handleSelect(idx, h)}>
                        {h.heroNm}
                      </button>
                    ))}
                  {allyHeroes.filter(h => h.heroNm.includes(searches[idx])).filter(h => !selected.some(s => s && s.heroId === h.heroId)).length === 0 && (
                    <div className="gw-hero-dropdown-empty">검색 결과 없음</div>
                  )}
                </div>
              )}
            </div>
          ))}
        </section>

        <div className="gw-footer">
          <button className="gw-btn" onClick={() => navigate(-1)}>취소</button>
          <button className="gw-btn primary" onClick={handleSave} disabled={saving}>
            {saving ? '등록 중...' : '등록'}
          </button>
        </div>
      </div>
    </div>
  );
}
